import { NgModule } from '@angular/core'
import { EditorModule } from 'primeng/editor';

import { HubComponentsModule } from '@hub-components'

import {
  ChartComponent,
  MapComponent,
  AreaChartComponent,
  BarChartComponent,
  LineChartComponent,
  PieChartComponent,
  KpiComponent,
  TableWidgetComponent,
  MapChartComponent,
  ComboChartComponent,
  WysiwygComponent,
  ImageWidgetComponent,
  DimensionValueComponent,
} from './components/widgets'
import { WidgetLoaderComponent } from './components/widget-loader.component'

const WIDGETS = [
  ChartComponent,
  MapComponent,
  AreaChartComponent,
  BarChartComponent,
  LineChartComponent,
  PieChartComponent,
  KpiComponent,
  TableWidgetComponent,
  MapChartComponent,
  ComboChartComponent,
  WysiwygComponent,
  ImageWidgetComponent,
  DimensionValueComponent,
]

export * from './components/widgets'
export { WIDGETS_BY_NAME } from './components/widgets'

@NgModule({
  declarations: [
    WIDGETS,
    WidgetLoaderComponent,
  ],
  exports: [
    WIDGETS,
    WidgetLoaderComponent
  ],
  imports: [
    HubComponentsModule,
    EditorModule,
  ],
  providers: []
})
export class WidgetsModule {}
